import { BehaviorSubject } from 'rxjs';
import { IDevolutionDTO } from '../models/devolution.store.model';

export class DevolutionStoreState {
  // PRIVATE PROPS
  // BehaviorSubject mantém o estado atual
  private devolutionStateSubject = new BehaviorSubject<IDevolutionDTO | null>(null);

  // PUBLIC PROPS
  public _devolutionState$ = this.devolutionStateSubject.asObservable();

  // CONSTRUCTOR
  constructor() {
    this.setDevolution(null);
  }

  // METHODS

  // METHODS SETTERS
  public setDevolution(newState: IDevolutionDTO) {
    this.devolutionStateSubject.next(newState);
  }

  // METHODS GETTERS
  public getDevolution(): IDevolutionDTO | null {
    return this.devolutionStateSubject.getValue();
  }
}
